import Image from 'next/image';

import buySellLockInRate from '@/assets/images/buySellLockInRate.svg';
import cashTrust from '@/assets/images/cashTrust.svg';
import finCorpBranch from '@/assets/images/finCorpBranch.svg';
import kycDocs from '@/assets/images/kycDocs.svg';

const SellSteps = () => {
  return (
    <section className="step_to_get_forex">
      <div className="container">
        <h2 className="text--black text--bold section__title-small step-text text-center">
          4 Easy Steps to Get Forex
        </h2>
        <div className="row">
          <div className="col-lg-3">
            <div className="mb-lg-0  step-box">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={buySellLockInRate}
                alt="vision icon"
              />
              <p className="text--bold text--black title">STEP 1</p>
              <p className="text--gray text--regular desc step_detail">
                Book an appointment with us to schedule a branch visit
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="mb-lg-0 step-box">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={finCorpBranch}
                alt="mission icon"
              />
              <p className="text--bold text--black title">STEP 2</p>
              <p className="text--gray text--regular desc step_detail">
                Visit the nearest Muthoot FinCorp branch to exchange the
                currency
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="mb-lg-0 step-box  mb-0">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={kycDocs}
                alt="values icon"
              />
              <p className="text--bold text--black title">STEP 3</p>
              <p className="text--gray text--regular desc step_detail">
                Carry your documents to complete the KYC
              </p>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="mb-lg-0 step-box  mb-0">
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={cashTrust}
                alt="values icon"
              />
              <p className="text--bold text--black title">STEP 4</p>
              <p className="text--gray text--regular desc step_detail">
                Get money instantly transferred to your bank account
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default SellSteps;
